import React, { useState, useEffect, useCallback } from 'react';
import T from 'prop-types';

import ShareLinkForm from '../../../../../components/ShareForms/ShareLinkForm';

const ShareModalContent = ({
  shareUrl,
  requestUrl,
  onHide,
}) => {
  const [shared, setShared] = useState(false);

  useEffect(() => {
    let timeoutId;

    if (shared) {
      setTimeout(() => {
        onHide(false);
      }, 3000);
    }
    return () => clearTimeout(timeoutId);
  }, [shared]);

  const handleClose = useCallback(() => {
    onHide(false);
  }, []);

  const handleShareSuccess = useCallback(() => {
    setShared(true);
  }, []);

  return (
    <ShareLinkForm
      requestUrl={requestUrl}
      shareLinkUrl={shareUrl}
      successMessage="Mobile insights are on their way!"
      buttonText="Share report"
      className="share-modal-content-form"
      isMobileMode
      onClose={handleClose}
      onSubmitSuccess={handleShareSuccess}
    />
  );
};

ShareModalContent.propTypes = {
  shareUrl: T.string.isRequired,
  requestUrl: T.string.isRequired,
  onHide: T.func.isRequired,
};

export default ShareModalContent;
